<template>
  <div style="height: 100%; width: 100%; overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="productKey"
      :col="3"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :operationBoxStyle="{ padding: '0 0 16px' }"
      :requestPromise="loadDataList"
    >
      <!-- 操作按钮区域 -->
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建</a-button>
      
      <template v-slot:productName="{ record }">
        <a-tooltip :title="record.productName">
          <div class="ellipsis-cell product-name-cell">{{ record.productName }}</div>
        </a-tooltip>
      </template>

      <template v-slot:lineTitle="{ record }">
        <a-tooltip :title="formatConfigInfo(record)">
          <div class="ellipsis-cell config-info-cell">{{ formatConfigInfo(record) }}</div>
        </a-tooltip>
      </template>

      <!-- 操作 列 -->
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onRenameEvent(record)">改名</a>
          <!-- <a v-if="record.type === 'SINGLE'" @click="onConfigEvent(record)">改兜底</a> -->
          <a @click="onSwitchStatus(record)">
            {{ record.status == 1 ? '下架' : '上架' }}
          </a>
          <a @click="onDeleteEvent(record)">删除</a>
        </a-space>
      </template>
    </StandardSearchPageView>

    <!-- 新建 / 编辑产品弹窗 -->
    <product-create-dialog
      :visible.sync="createVisible"
      :edit-record="editRecord"
      @success="refreshData(true)"
      @close="editRecord = null"
    />

    <!-- 修改兜底价 -->
    <a-modal
      title="修改兜底价"
      :visible="fallbackVisible"
      :confirmLoading="fallbackLoading"
      okText="保存"
      destroyOnClose
      @ok="onSubmitFallback"
      @cancel="onCloseFallback"
    >
      <div class="fallback-tip">产品：{{ fallbackForm.productKey }}</div>
      <div class="fallback-form-item">
        <div class="fallback-label">票型：</div>
        <a-select
          v-model="fallbackForm.optionCode"
          placeholder="请选择票型"
          style="width: 100%"
          @change="onFallbackOptionChange"
        >
          <a-select-option
            v-for="opt in fallbackOptions"
            :key="opt.optionCode"
            :value="opt.optionCode"
          >
            {{ opt.optionName || opt.optionCode }}（{{ opt.optionCode }}）
          </a-select-option>
        </a-select>
      </div>
      <div class="fallback-form-item">
        <div class="fallback-label">兜底价：</div>
        <a-input-number
          v-model="fallbackForm.fallbackPriceHkd"
          :min="0"
          :precision="2"
          placeholder="请输入港币兜底价"
          style="width: 100%"
        />
      </div>
    </a-modal>

    <!-- 改名：仅展示产品名 -->
    <a-modal
      :title="`改名产品: ${renameForm.productKey}`"
      :visible="renameVisible"
      :footer="null"
      destroyOnClose
      :width="520"
      wrapClassName="product-rename-dialog"
      @cancel="onCloseRename"
    >
      <div class="rename-section">
        <div class="rename-section-title">
          <span class="rename-section-index">1</span>
          产品名 &amp; 保存
        </div>
        <div class="rename-form-item">
          <a-input v-model="renameForm.productName" placeholder="请输入产品名" />
        </div>
        <a-button type="primary" block class="rename-save-btn" :loading="renameLoading" @click="onSubmitRename">
          保存修改
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ProductCreateDialog from './ProductCreateDialog.vue'

export default {
  name: 'ProductConfigComponent',
  components: {
    StandardSearchPageView,
    ProductCreateDialog
  },
  data () {
    return {
      createVisible: false,
      editRecord: null,
      fallbackVisible: false,
      fallbackLoading: false,
      fallbackOptions: [],
      fallbackForm: {
        productKey: '',
        optionCode: undefined,
        fallbackPriceHkd: undefined
      },
      renameVisible: false,
      renameLoading: false,
      renameRecord: null,
      renameForm: {
        productKey: '',
        productName: ''
      },
      queryParams: {
        productKey: '',
        productName: '',
        type: ''
      },
      searchOptions: [
        {
          name: '产品KEY',
          key: 'productKey',
          type: 'input',
          placeholder: '请输入产品KEY'
        },
        {
          name: '名称',
          key: 'productName',
          type: 'input',
          placeholder: '如 三次购票'
        },
        {
          name: '类型',
          key: 'type',
          type: 'select',
          selectOptions: [
            { label: '全部', value: '' },
            { label: 'SINGLE', value: 'SINGLE' },
            { label: 'PKG', value: 'PKG' }
          ]
        }
      ]
    }
  },
  methods: {
    loadDataList (params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto:undefined,
      }
      return this.getHttpServices().getSourceService().post('/hkdl/config/admin/products/list', requestParams)
    },

    /**
     * 获取列定义
     */
    getColumns () {
      return [
        {
          title: '产品KEY',
          dataIndex: 'productKey',
          key: 'productKey',
          width: 130
        },
        {
          title: 'EVENT',
          dataIndex: 'eventId',
          key: 'eventId',
          width: 100,
        },
        {
          title: '产品信息',
          dataIndex: 'productName',
          key: 'productName',
          width: 110,
          scopedSlots: { customRender: 'productName' }
        },
        {
          title: '票型/库存配置',
          dataIndex: 'configInfo',
          key: 'configInfo',
          width: 480,
          scopedSlots: { customRender: 'lineTitle' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
          width: 100
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 80,
          customRender: text => (text == 1 ? '上架' : '下架')
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          width: 170,
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 280,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },


    /**
     * 格式化票型/库存配置列
     */
    formatConfigInfo (record) {
      if (!record) return '---'
      if (record.type === 'SINGLE' && Array.isArray(record.options) && record.options.length > 0) {
        return record.options
          .map(opt => {
            const parts = []
            if (opt.optionName) parts.push(opt.optionName)
            if (opt.optionCode) parts.push(`ID:${opt.optionCode}`)
            if (opt.adultCount !== undefined && opt.adultCount !== null) {
              parts.push(`成人${opt.adultCount}`)
            }
            if (Array.isArray(opt.ticketMps) && opt.ticketMps.length > 0) {
              parts.push(`票${opt.ticketMps.join(',')}`)
            }
            if (opt.fallbackPriceHkd) {
              parts.push(`兒慶HK$${opt.fallbackPriceHkd}`)
            }
            if (opt.addSalePrice) {
              parts.push(`追加¥${opt.addSalePrice}`)
            }
            return parts.join(' - ')
          })
          .join('; ')
      } else if (record.type === 'PKG' && Array.isArray(record.components) && record.components.length > 0) {
        return record.components
          .map(comp => {
            const parts = []
            if (comp.name) parts.push(comp.name)
            if (comp.ticketMp) parts.push(`票:${comp.ticketMp}`)
            if (comp.quantity) parts.push(`数量:${comp.quantity}`)
            return parts.join(' - ')
          })
          .join('; ')
      }
      return '---'
    },

    /**
     * 刷新表格数据
     */
    refreshData (reset = false) {
      if (this.$refs.table) {
        this.$refs.table.refresh(reset)
      }
    },

    /**
     * 点击新建
     */
    onAddEvent () {
      this.editRecord = null
      this.createVisible = true
    },

    /**
     * 点击编辑
     */
    onEditEvent (record) {
      this.editRecord = record
      this.createVisible = true
    },

    /**
     * 点击改名
     * PUT /hkdl/config/admin/products/{productKey}（与编辑同接口，弹窗仅改名）
     */
    onRenameEvent (record) {
      if (!record || !record.productKey) return
      this.renameRecord = record
      this.renameForm = {
        productKey: record.productKey,
        productName: record.productName || ''
      }
      this.renameVisible = true
    },

    onCloseRename () {
      this.renameVisible = false
      this.renameLoading = false
      this.renameRecord = null
      this.renameForm = {
        productKey: '',
        productName: ''
      }
    },

    buildRenamePayload (record, productName) {
      if (record.type === 'PKG') {
        return {
          type: 'PKG',
          productName,
          components: (record.components || []).map(comp => ({
            ticketMp: String(comp.ticketMp),
            itemType: Number(comp.itemType),
            quantity: Number(comp.quantity)
          }))
        }
      }
      return {
        type: 'SINGLE',
        productName,
        eventId: record.eventId != null ? String(record.eventId) : undefined,
        eventType: record.eventType,
        options: (record.options || []).map((opt, index) => ({
          optionName: opt.optionName || `票型 ${index + 1}`,
          adults: opt.adults != null ? Number(opt.adults) : (opt.adultCount != null ? Number(opt.adultCount) : 1),
          fallbackPriceHkd: opt.fallbackPriceHkd != null && opt.fallbackPriceHkd !== ''
            ? Number(opt.fallbackPriceHkd)
            : null,
          addSalePrice: opt.addSalePrice != null && opt.addSalePrice !== ''
            ? Number(opt.addSalePrice)
            : null,
          ticketIds: (opt.ticketIds || opt.ticketMps || []).map(id => String(id))
        }))
      }
    },

    onSubmitRename () {
      const productName = (this.renameForm.productName || '').trim()
      if (!productName) {
        this.$message.warning('请填写产品名')
        return
      }
      if (!this.renameRecord) return

      const payload = this.buildRenamePayload(this.renameRecord, productName)
      this.renameLoading = true
      this.getHttpServices().getSourceService()
        .put(`/hkdl/config/admin/products/${this.renameForm.productKey}`, payload)
        .then(() => {
          this.$message.success('改名成功')
          this.onCloseRename()
          this.refreshData()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '改名失败，请重试！')
        })
        .finally(() => {
          this.renameLoading = false
        })
    },

    /**
     * 点击改兜底
     * POST /hkdl/config/admin/options/{optionCode}/fallback
     */
    onConfigEvent (record) {
      if (!record || record.type !== 'SINGLE') {
        this.$message.warning('仅 SINGLE 单票支持修改兜底价')
        return
      }
      const options = (record.options || []).filter(opt => opt && opt.optionCode)
      if (!options.length) {
        this.$message.warning('该产品暂无可用票型 optionCode')
        return
      }
      this.fallbackOptions = options
      this.fallbackForm = {
        productKey: record.productKey,
        optionCode: options[0].optionCode,
        fallbackPriceHkd: options[0].fallbackPriceHkd != null ? Number(options[0].fallbackPriceHkd) : undefined
      }
      this.fallbackVisible = true
    },

    onFallbackOptionChange (optionCode) {
      const opt = this.fallbackOptions.find(item => item.optionCode === optionCode)
      this.fallbackForm.fallbackPriceHkd = opt && opt.fallbackPriceHkd != null
        ? Number(opt.fallbackPriceHkd)
        : undefined
    },

    onCloseFallback () {
      this.fallbackVisible = false
      this.fallbackLoading = false
      this.fallbackOptions = []
      this.fallbackForm = {
        productKey: '',
        optionCode: undefined,
        fallbackPriceHkd: undefined
      }
    },

    onSubmitFallback () {
      const { optionCode, fallbackPriceHkd } = this.fallbackForm
      if (!optionCode) {
        this.$message.warning('请选择票型')
        return
      }
      if (fallbackPriceHkd === undefined || fallbackPriceHkd === null || fallbackPriceHkd === '') {
        this.$message.warning('请输入兜底价')
        return
      }
      this.fallbackLoading = true
      this.getHttpServices().getSourceService()
        .post(`/hkdl/config/admin/options/${optionCode}/fallback`, {
          fallbackPriceHkd: Number(fallbackPriceHkd)
        })
        .then(() => {
          this.$message.success('修改兜底价成功')
          this.onCloseFallback()
          this.refreshData()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '修改兜底价失败，请重试！')
        })
        .finally(() => {
          this.fallbackLoading = false
        })
    },

    /**
     * 点击上架/下架
     */
    onSwitchStatus (record) {
      const isOn = record.status == 1
      const actionText = isOn ? '下架' : '上架'
      this.$confirm({
        title: '提示',
        content: `确认要${actionText}产品【${record.productKey}】吗？`,
        onOk: () => {
          const service = this.getHttpServices().getSourceService()
          const request = isOn
            ? service.post(`/hkdl/config/admin/products/${record.productKey}/down`)
            : service.post(`/hkdl/config/admin/products/${record.productKey}/enable`)
          request.then(() => {
            this.$message.success(`${actionText}成功`)
            this.refreshData()
          }).catch(err => {
            this.$message.error((err && err.msg) || `${actionText}失败，请重试！`)
          })
        }
      })
    },

    /**
     * 点击删除
     * DELETE /hkdl/config/admin/products/{productKey}
     */
    onDeleteEvent (record) {
      if (!record || !record.productKey) return
      this.$confirm({
        title: '提示',
        content: `确认要删除产品【${record.productKey}】吗？删除后不可恢复。`,
        okType: 'danger',
        onOk: () => {
          return this.getHttpServices().getSourceService()
            .delete(`/hkdl/config/admin/products/${record.productKey}`)
            .then(() => {
              this.$message.success('删除成功')
              this.refreshData()
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '删除失败，请重试！')
              return Promise.reject(err)
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-name-cell {
  width: 90px;
}

.config-info-cell {
  width: 448px;
}

.fallback-tip {
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.65);
}

.fallback-form-item {
  margin-bottom: 16px;
}

.fallback-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
}

.rename-section {
  padding: 4px 0;
}

.rename-section-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);

  .rename-section-index {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    line-height: 20px;
    border-radius: 50%;
    background: #fa8c16;
    color: #fff;
    font-size: 13px;
    text-align: center;
  }
}

.rename-form-item {
  margin-bottom: 12px;

  .rename-label {
    margin-bottom: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
  }
}

.rename-save-btn {
  background: #fa8c16;
  border-color: #fa8c16;

  &:hover,
  &:focus {
    background: #ffa940;
    border-color: #ffa940;
  }
}
</style>

